enum CalloutVariant{
    information = "information", 
    important = "important", 
    emergency = "emergency", 
    success="success",
    event="event"
}

export default CalloutVariant;